import { render } from "./Carousel.vue?vue&type=template&id=2e9f5729"
import script from "./Carousel.vue?vue&type=script&lang=js"
export * from "./Carousel.vue?vue&type=script&lang=js"

import "./Carousel.vue?vue&type=style&index=0&id=2e9f5729&lang=scss"
script.render = render

export default script